export default {
  DISCORD: "https://discord.gg/acre",
  DOCS: "https://docs.acre.fi",
  FAQ: "https://docs.acre.fi/faq",
  CONTRACTS: "https://docs.acre.fi/contracts",
  BLOG: "https://blog.acre.fi",
  MEZO_INFO: "https://info.mezo.org",
  WEBSITE: "https://acre.fi",
  TERMS_OF_USE: "https://acre.fi/terms-of-use",
  PRIVACY_POLICY: "https://acre.fi/privacy-policy",
  X: "https://x.com/AcreBTC",
}
